import { defineComponent as _defineComponent } from 'vue'
import type { WebSearchResult } from '@@/bits/web_search'
import { nextTick, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'content-picker-search-results-web',
  props: {
    results: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'select', url: string): void
}), expose: any, slots: any, attrs: any }) {





const hoveringOn = ref<number | null>(null)

function onSelect(url: string) {
  emit('select', url)
}

function onHover(index: number) {
  nextTick(() => (hoveringOn.value = index))
}

function onStopHover() {
  hoveringOn.value = null
}

return { __sfc: true,emit, hoveringOn, onSelect, onHover, onStopHover }
}

})